import api from '@api/Api';

export default {

    generate() {
        return api().get('/authy/generate');
    },

    register(token) {
        return api().post(`/authy/register/${token}`);
    },

    validate(token) {
        return api().post(`/authy/validate/${token}`);
    },

    deactivate() {
        return api().post('/authy/deactivate/');
    },

}
